import { AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, Input, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CityService } from '@city/feature';
import { EnvironmentService } from '@core/feature';
import { DropdownComponent, DropdownMenuComponent, SdvorButtonComponent } from '@sdvor/shared/ui/v2';

@Component({
  selector: 'sd-city-defined-confirmation',
  templateUrl: './city-defined-confirmation.component.html',
  styleUrls: ['./city-defined-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorButtonComponent, DropdownComponent, DropdownMenuComponent],
})
export class CityDefinedConfirmationComponent implements AfterViewInit {
  @Input() cityName: string;

  @ViewChild('dropdown') dialogDropdown: DropdownComponent;

  constructor(
    private cityService: CityService,
    private environmentService: EnvironmentService,
    private destroyRef: DestroyRef,
  ) {}

  ngAfterViewInit(): void {
    if (this.environmentService.isPlatformServer) {
      return;
    }

    this.cityService.openCityDefinedDialogEvent.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.dialogDropdown.open();
    });
  }

  onOpenCityList(): void {
    this.cityService.openCityList();
  }

  onDialogOpenChange(isOpen: boolean): void {
    if (isOpen === false) {
      this.cityService.setActiveBaseStoreToCookie();
    }
  }
}
